export default function (context) {
  if (context.route.fullPath.includes('/loismapviewer/buildings')) {
    return context.redirect(301, `${context.$config.loisMapViewerUrl}/buildings`, context.route.query)
  }
}
